<template>
  <div>
    <v-card
      class="mx-auto mb-3 card-box main-card work-overtime with-avatar"
      elevation="0"
    >
      <v-card-title class="pa-0" @click="goPage()">
        연장근무 보상시간
        <v-icon class="ml-auto pa-0 mr-n4" color="#505961">
          mdi-chevron-right
        </v-icon>
      </v-card-title>

      <v-row class="ma-0 mt-4">
        <v-row class="ma-0 card-header" justify="space-between">
          <v-col class="pa-0 text-center" cols="12">
            <v-avatar size="58" color="#ffffff">
              <icon-overtime :width="24" :height="24" size="24" />
            </v-avatar>
          </v-col>
          <v-col cols="12" class="pa-0 text-center pt-4 desc">
            잔여
            <span class="point-blue cnt">{{ restTime }}</span>
            시간에 대해<br />보상휴가 신청을 작성해주세요.
          </v-col>
        </v-row>
      </v-row>

      <v-card-actions class="pa-0 justify-center" v-if="applBtnFlag">
        <v-row align="center" justify="space-around" class="ma-0 btn-wrap">
          <v-btn
            class="v-btn"
            block
            elevation="0"
            color="#465166"
            @click="toRewardApplication()"
          >
            <span class="white--text">보상휴가신청</span>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
/* 연장근무보상시간 위젯 컴포넌트 */
import IconOvertime from '@/assets/customIcon/IconOvertime.vue';
import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';

export default {
  props: {
    restTime: {
      type: Number,
      default: 0,
    },
    applBtnFlag: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /* 페이지이동 */
    goPage() {
      this.$router.push({ name: routerNames.WorkOverTimeSta }); // 연장근무 보상시간 현황
    },
    /* 보상휴가 신청화면으로 이동 */
    async toRewardApplication() {
      const routerName = await this.$store.dispatch('ELA/FETCH_MENU_ACTION', {
        applCd: applCode.Reward,
        gubun: 'works',
      });
      this.$router.push(routerName);
    },
  },
  components: {
    IconOvertime,
  },
};
</script>
